const getTermsAndConditionsByCurrency = (termsAndConditions, currencyCode) => (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions[`promotion_terms_${(currencyCode || 'eur').toLowerCase()}`]) ||
    (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions['promotion_terms_eur'.toLowerCase()]) ||
    '';

export { getTermsAndConditionsByCurrency };
//# sourceMappingURL=promotion.js.map
